import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-ink px-4">
      <div className="card-k w-full max-w-md p-8">
        <h1 className="font-display text-3xl font-bold uppercase text-white">Reset Password</h1>
        {sent ? (
          <p data-testid="forgot-sent" className="mt-5 text-sm text-slate-300">If that email is registered, a reset link has been sent. Please check your inbox.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input data-testid="forgot-email" type="email" required placeholder="Admin email" className="input-k" value={email} onChange={(e) => setEmail(e.target.value)} />
            <button data-testid="forgot-submit" disabled={busy} className="btn-kinetic btn-primary-k w-full justify-center disabled:opacity-60">{busy ? "Sending..." : "SEND RESET LINK"}</button>
          </form>
        )}
        <Link to="/admin/login" className="mt-5 inline-block text-xs text-brand-cyan hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-ink px-4">
      <div className="card-k w-full max-w-md p-8">
        <h1 className="font-display text-3xl font-bold uppercase text-white">New Password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="reset-password-input" type="password" required minLength={8} placeholder="New password (min 8 chars)" className="input-k" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="reset-submit" disabled={busy || !token} className="btn-kinetic btn-primary-k w-full justify-center disabled:opacity-60">{busy ? "Updating..." : "UPDATE PASSWORD"}</button>
        </form>
        <Link to="/admin/login" className="mt-5 inline-block text-xs text-brand-cyan hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}
